"use client"
// import classNames from 'classnames';
import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import DialogComponent from '@/Inputs/DailogComponent';
import { Form, Formik } from 'formik';
import AddressSection from './AddressForm';
import { customerUpdateApi } from '@/services/Redux/Reducer/LoginSlice';
import parse from 'html-react-parser';
import ButtonComponent from '@/Inputs/ButtonComponent';
import { ContextData, MiniLoader, storeAssigned } from '@/services/Methods/normalMethods';
import CheckoutValidationSchema from '@/components/checkoutSteps/CheckoutValidationSchema';

const AddessOptionStyle = styled.div`
    &.mainAddress_option {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        width: 100%;

        
        .address_line {
            width: 100%;
            .MuiFormControl-root {
                width: 100%;
            }
            .addAddress_class {
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid;
                margin-bottom: 10px;
                padding:0 4px;

                @media only screen and (max-width:640px) {
                    flex-wrap: wrap;
                    justify-content: center;
                    text-align: center;
                }

                p {
                    margin-bottom: 4px;
                    font-weight: 600;
                    @media only screen and (max-width:640px) {
                        display: block;
                        width: 100%;
                    }
                    &:first-child {
                        color: #000;
                        font-size: 22px;
                    }
                    &:last-child {
                        font-weight: 600;
                        cursor: pointer;
                        color: #000;
                    }
                }
            }
            .radio_section {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                /* gap: 10px; */
                margin-bottom: 4px;
                padding: 8px 13px 8px 0px;

                &>div {
                    margin-left: 42px;
                }

                .MuiRadio-root {
                    padding:9px !important;
                }

                @media only screen and (max-width: 767px) {
                    flex-direction: column;
                    align-items: flex-start;
                }

                &.activeAddress{
                    background: #2a533f1a;
                    border-radius: 5px;
                }
                label {
                    margin: 0; 

                    @media only screen and (max-width: 767px) {
                        align-items: flex-start;
                    }

                    .MuiButtonBase-root {
                        @media only screen and (max-width: 767px) {
                            padding: 0 9px;
                        }   
                    }

                    p {
                        margin-bottom: 0;
                        strong {
                            font-size: 18px;
                        }
                    }
                }
                .editIcon {
                    color: #0171ba;
                    cursor: pointer;
                    font-weight: 600;
                    font-size: 14px;
                    &:hover {
                        border-bottom: 1px solid #0171ba;
                    }
                }
                .DelIcon {
                    color: #f00;
                    &:hover {
                        border-bottom: 1px solid #f00;
                    }
                }

                &>div {
                    @media only screen and (max-width: 767px) {
                        width: calc(100% - 40px);
                        margin-left: 40px;
                    }
                }
            }
        }
    }

`;

const AddressOptions = ({
    allUserData, _setUseDefaultAddressFunction, userFormData, setUserFormData, setDefaultValues, dispatch,
    sameAsBillingChecked, _paymentOptionSetBilling, checkoutError, section, ...props
}) => {

    const { countyObjects } = useContext(ContextData);
    const [addressObject, setAddressesObject] = useState({ oldData: {}, shippingAddress: {}, addresses: [] });
    const [openDialog, setOpenDialog] = useState(null);

    const [marketOpenDialog, setMarketOpenDialog] = useState(false);


    function userDataPayload(data) {
        return ({
            "shipping_urname": allUserData?.firstName,
            "shipping_lastname": allUserData?.lastName,
            "shipping_email": allUserData?.emailAddress,
            "search_enroller": allUserData?.search_enroller,
            "shipping_phone": allUserData?.phoneNumbers?.cellPhone,
            "shipping_delivery": '',
            "shipping_street": data?.address1,
            "shipping_street2": data?.address2,
            "shipping_city": data?.city,
            "shipping_zipcode": data?.postalCode,
            "shipping_country": data?.countryCode,
            "shipping_state": data?.regionProvState,
            "webAlias": data?.webAlias || '',
            "dob": allUserData?.birthDate || ''

        })
    }

    function _addressPayload(values) {
        return ({
            address1: values?.shipping_street || '',
            "address2": values?.shipping_street2 || "",
            "address3": "",
            city: values?.shipping_city || "",
            regionProvState: values?.shipping_state || "",
            postalCode: values?.shipping_zipcode || "",
            countryCode: values?.shipping_country || ""
        })
    }


    useEffect(() => {
        if (allUserData?.emailAddress) {
            const PICK_ADDRESSES = _.pick(allUserData, ['shippingAddress', 'otherAddress1', 'otherAddress2']);

            const ADDRESSES = _.compact(_.map(_.values(PICK_ADDRESSES), (val, index) => {
                const SECTION = _.keys(PICK_ADDRESSES);
                if (SECTION[index] !== "shippingAddress") {
                    const { address1, city, postalCode } = PICK_ADDRESSES?.shippingAddress;
                    if (val?.address1 !== address1) {
                        return ({
                            id: index + 1,
                            firstName: allUserData?.firstName,
                            lastName: allUserData?.lastName,
                            webAlias: allUserData?.webAlias || '',
                            section: SECTION[index], ...val
                        });
                    }
                } else {
                    return ({
                        id: index + 1,
                        firstName: allUserData?.firstName,
                        lastName: allUserData?.lastName,
                        webAlias: allUserData?.webAlias || '',
                        section: SECTION[index], ...val
                    });
                }
            }))
            const FilterAddresAccStore = _.filter(ADDRESSES, (r) => r?.countryCode === _.upperCase(storeAssigned()));
            setAddressesObject({
                oldData: allUserData,
                shippingAddress: _.find(FilterAddresAccStore, (r) => r?.address1 !== ''),
                addresses: ADDRESSES
            });
            const NEW_ADDRESS = userDataPayload(_.find(FilterAddresAccStore, (r) => r?.address1 !== ''));
            setUserFormData({ ...userFormData, ...NEW_ADDRESS });
            _setUseDefaultAddressFunction(null, null, userDataPayload(_.find(FilterAddresAccStore, (r) => r?.address1 !== '')));
            if (section !== 'autoship_edit') {
                // setDefaultValues((prv) => ({ ...prv, ...PICK_ADDRESSES }))
            }
        }
    }, [allUserData?.emailAddress]);

    function _selectedDefaulAddress(selectAddress) {
        setAddressesObject((pre) => ({ ...pre, shippingAddress: selectAddress }));
        let CONVERTED_ADDRESS = userDataPayload(selectAddress);
        setUserFormData(CONVERTED_ADDRESS);
        if (sameAsBillingChecked) {
            _paymentOptionSetBilling(CONVERTED_ADDRESS);
        }
        _setUseDefaultAddressFunction(null, null, CONVERTED_ADDRESS)
    }

    function _handleOpenDialog(row, section) {
        if (!row && section === 'add') {
            setUserFormData({ ...userFormData, shipping_city: "", shipping_street2: "", shipping_street: "", shipping_zipcode: "", shipping_delivery: "" });
            let SELECT_ROW = _.find(addressObject?.addresses, (row) => !row?.address1);
            const SIPPING_ADDRESS_CHECK = _.find(addressObject?.addresses, (row) => {
                return row?.section === "shippingAddress" && !row?.address1
            })
            if (SIPPING_ADDRESS_CHECK) {
                SELECT_ROW = SIPPING_ADDRESS_CHECK;

            }

            setOpenDialog(SELECT_ROW?.id);
        } else {
            setOpenDialog(row?.id);
            const BILLING_DETAIL = userDataPayload(_.find(addressObject?.addresses, { id: row?.id }));
            props?.setCountryState((prv) => ({ ...prv, country: BILLING_DETAIL?.shipping_country, state: BILLING_DETAIL?.shipping_state }))
            setUserFormData({ ...userFormData, ...BILLING_DETAIL });
        }
    }

    function _handleCloseFunction() {
        setOpenDialog(null);
        setUserFormData(userDataPayload(_.find(addressObject?.addresses, { id: addressObject?.shippingAddress?.id })));
        // setUserFormData({ ...userFormData, shipping_city: "", shipping_phone: "", shipping_street: "", shipping_street2: "", shipping_zipcode: "", shipping_delivery: "" });
    }

    function _deleteAddress(id) {
        const AFTER_DELTED_DATA = _.reject(addressObject?.addresses, { id: id });
        const PAYLOAD = _addressPayload();
        const FIND_ADDRESS_SECTION = _.find(addressObject?.addresses, { id })?.section;

        dispatch(customerUpdateApi({
            ...allUserData,
            ...addressObject?.oldData,
            [FIND_ADDRESS_SECTION]: _addressPayload()
        }, 'addressUpdate', allUserData?.customerId, () => {

            // const PICK_ADDRESSES = _.pick({ ...addressObject?.oldData, [_.find(addressObject?.addresses, { id })?.section]: _addressPayload() }, ['shippingAddress', 'billingAddress', 'mailingAddress', 'otherAddress1', 'otherAddress2']);

            if (section !== 'autoship_edit') {
                // setDefaultValues((prv) => ({ ...prv, ...PICK_ADDRESSES }));
            }
            const ADDRESS_SELECTION = +(addressObject?.shippingAddress?.id === +id) ? userDataPayload(AFTER_DELTED_DATA[0]) : userDataPayload(addressObject?.shippingAddress)
            setUserFormData(ADDRESS_SELECTION);
            setAddressesObject((prv) => ({
                oldData: { ...prv?.oldData, [FIND_ADDRESS_SECTION]: _addressPayload() },
                shippingAddress: (prv?.shippingAddress?.id === id) ? AFTER_DELTED_DATA[0] : prv?.shippingAddress,
                addresses: [...AFTER_DELTED_DATA, { id, section: FIND_ADDRESS_SECTION, ...PAYLOAD }]
            }));
            // _setUseDefaultAddressFunction(null, null, userDataPayload(ADDRESS_SELECTION))

        }));
    }

    function _submitFunctionPop(values) {
        try {
            const FIND_ADDRESS_SECTION = _.find(addressObject?.addresses, { id: +openDialog })?.section;

            const PAYLOAD = _addressPayload(values);
            dispatch(customerUpdateApi({
                ...allUserData,
                ...addressObject?.oldData,
                [FIND_ADDRESS_SECTION]: PAYLOAD
            }, 'addressUpdate', allUserData?.customerId, () => {
                setAddressesObject((prv) => ({
                    oldData: { ...prv?.oldData, [FIND_ADDRESS_SECTION]: PAYLOAD },
                    shippingAddress: { id: +openDialog, ...PAYLOAD },
                    addresses: [..._.reject(addressObject?.addresses, { id: +openDialog }), { id: +openDialog, section: FIND_ADDRESS_SECTION, ...{ firstName: values?.shipping_urname, lastName: values?.shipping_lastname, ...PAYLOAD } }]
                }));
                // const PICK_ADDRESSES = _.pick({ ...addressObject?.oldData, [_.find(addressObject?.addresses, { id: +openDialog })?.section]: PAYLOAD }, ['shippingAddress', 'billingAddress', 'mailingAddress', 'otherAddress1', 'otherAddress2']);
                // if (section !== 'autoship_edit') {
                //     setDefaultValues((prv) => ({ ...prv, ...PICK_ADDRESSES }));
                // }
                setUserFormData(values);
                if (sameAsBillingChecked) {
                    _paymentOptionSetBilling(values);
                }
                setOpenDialog(null);
            }));
        } catch (err) {
            console.log(err, 'dddddddddddddddddddddddddddd')
        }

    }
    return (
        <AddessOptionStyle className='mainAddress_option'>
            <div className='address_line mb-[34px]'>
                <div className='addAddress_class'>
                    <p>Your addresses</p>
                    {_.find(addressObject?.addresses, (row) => !row?.address1) &&
                        <p onClick={() => _handleOpenDialog(null, 'add')}>Ship to a new address</p>
                    }
                </div>
                {(_.filter(addressObject?.addresses, (r) => (r?.countryCode === _.upperCase(storeAssigned()) && r?.address1))?.length > 0)
                    ?
                    <FormControl>
                        <RadioGroup value={String(addressObject?.shippingAddress?.id)} className="radio_main_group" name="radio-buttons-group">
                            {_.map([
                                ..._.filter(addressObject?.addresses, (r) => (r?.countryCode === _.upperCase(storeAssigned()) && r?.address1)),
                            ], (row) => (
                                <React.Fragment key={'address' + row?.id}>
                                    {(row?.address1) &&
                                        // <div className={classNames('radio_section', { 'activeAddress': (addressObject?.shippingAddress?.id === row?.id) })}>
                                        <div className={'radio_section' + (addressObject?.shippingAddress?.id === row?.id ? ' activeAddress' : '')}>
                                            <FormControlLabel onChange={() => _selectedDefaulAddress(row)} value={String(row?.id)} control={<Radio sx={{
                                                color: '#000',
                                                '&.Mui-checked': {
                                                    color: '#000',
                                                },
                                            }} />} label={parse(`
                                            <p>
                                                <strong>${row?.firstName}&nbsp;${row?.lastName}</strong>
                                                <strong>${row?.address1}</strong>,
                                                <span> ${row?.address2 ? row?.address2 + ',' : ""}</span>
                                                <span>${row?.city}, ${row?.regionProvState}, ${row?.postalCode}</span>
                                                <span>${row?.countryCode}</span>
                                            </p>
                                            `)} />
                                            <div>
                                                <span className='editIcon' onClick={() => _handleOpenDialog(row, 'edit')}>Edit address</span>

                                                {addressObject?.shippingAddress?.id !== row?.id &&
                                                    <>
                                                        &nbsp;|&nbsp;
                                                        <span className=' editIcon DelIcon' onClick={() => _deleteAddress(+row?.id)} >Delete</span>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            ))}
                        </RadioGroup>
                    </FormControl>
                    :
                    <div className='flex gap-[20px] justify-center items-center text-center h-[100px]'>
                        {_.find(addressObject?.addresses, (row) => !row?.address1) &&
                            <>
                                <p
                                    className='cursor-pointer text-[#0171ba] text-sm text-center hover:border-b hover:border-[#0171ba]'
                                    onClick={() => _handleOpenDialog(null, 'add')}> Create a new address</p>
                                {/* <p>Or</p> */}
                            </>
                        }
                        {((_.filter(addressObject?.addresses, (r) => r?.address1)?.length > 0) && section !== "autoship_edit") &&
                            <p
                                onClick={() => setMarketOpenDialog(true)}
                                className='cursor-pointer text-[#0171ba] text-sm text-center hover:border-b hover:border-[#0171ba]'
                            >Or Change the market</p>
                        }
                    </div>
                }
                {(_.filter(addressObject?.addresses, (r) => r?.address1)?.length > 0) &&
                    <div className='text-[16px] text-red-500 font-semibold'>{checkoutError}</div>
                }
            </div>
            <DialogComponent opend={!!openDialog} handleClose={() => _handleCloseFunction()} title={(!userFormData?.shipping_city ? "Add" : "Edit") + ' ' + 'Address'} classFor="addessForm">
                <Formik
                    enableReinitialize
                    validationSchema={CheckoutValidationSchema(2)}
                    initialValues={userFormData}
                    onSubmit={(values) => _submitFunctionPop(values)}>
                    {(fieldValue) => {
                        const FieldMethod = fieldValue;
                        return (
                            <Form>
                                <AddressSection disabled={false} section="shipping" fieldValue={FieldMethod} {...props} />
                                {/* <DialogActions className='button_action'> */}
                                <div className='text-center flex flex-col items-center'>
                                    <ButtonComponent
                                        disabled={!!props?.normalAddressError}
                                        classes='w-full 2xl:max-w-[247px] xl:max-w-[220px] max-w-[200px] xl:mb-1.5 md:mb-1.5 2xl:pt-[13px] xl:pt-[11px] pt-[10px] 2xl:pb-[12px] xl:pb-[10px] pb-[9px] px-[20px] text-white 2xl:text-[20px] xl:text-[19px] text-[18px] font-medium' type="submit" >

                                        {props?.isLoading ? <MiniLoader /> : 'Submit'}
                                    </ButtonComponent>
                                </div>
                                {/* </DialogActions> */}
                            </Form>
                        )
                    }}
                </Formik>
            </DialogComponent>
        </AddessOptionStyle >
    );
}

export default AddressOptions;